import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { useSelector, useDispatch } from 'react-redux'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import styled from 'styled-components'



export default function index() {
  const dispatch = useDispatch()
  const { organization, dateFilter, selected, resident } = useSelector(state=>state)
  const { date, view } = dateFilter
  const canAddToAgenda = !!useSelector(state=>state.current_user.roles).find(role=> role != 'create_and_view')


  function updateFilterDate(payload){
    dispatch({type:"UPDATE_FILTER_DATE", payload: payload.format("YYYY-MM-DD")})
  }

  function handleNext(){
    switch(view){
      case "agenda":
      return updateFilterDate(moment(date).add(1, 'days'))
    case "week":
      return updateFilterDate(moment(date).add(1, 'weeks'))
    case "month":
      return updateFilterDate(moment(date).add(1, 'months'))
    }
  }

  function handlePrevious(){
    switch(view){
      case "agenda":
      return updateFilterDate(moment(date).subtract(1, 'days'))
    case "week":
      return updateFilterDate(moment(date).subtract(1, 'weeks'))
    case "month":
      return updateFilterDate(moment(date).subtract(1, 'months'))
    }
  }


  return (
    <div className="border-bottom border-top">
      <div className="text-center pt-2 text-capitalize" style={{ fontWeight: '500' }}>{selected.name}</div>
      <div className="d-flex p-3 align-items-center justify-content-between">
        <div className="w-33 d-none d-lg-block">
          <div className="col-10 col-xl-6 p-0">
            <Select
              onChange={(option)=>dispatch({type: "UPDATE_VIEW", payload: option.value})}
              options={options}
              value={options.filter(option=> option.value == view)}/>
          </div>
        </div>
        <FilterContainer className="d-flex justify-content-center">
          <button onClick={()=>handlePrevious()} className="btn btn-primary mr-2">
            <i className="fas fa-chevron-left"/>
          </button>
          <DatePicker
            selected={moment(date)}
            onChange={newDate => updateFilterDate(newDate)}
            dateFormat="LL"
            customInput={<DateInput date={date} handleChange={updateFilterDate}/>}
            />
          <button onClick={()=>handleNext()} className="btn btn-primary ml-2">
            <i className="fas fa-chevron-right"/>
          </button>
        </FilterContainer>
        <div className="w-33 d-none d-lg-block">
          <div className="d-flex justify-content-end w-100">
          {
            canAddToAgenda &&
            <a 
              className="btn btn-primary d-flex align-items-center"
              style={{height: '43px'}}
              href={`/organizations/${organization.name}/new_agenda_resource${ !!resident.id ? `?from_resident_profile=${resident.id || ''}` : ''}`}>
              <i className="fas fa-plus pr-2"/>
              Add To Agenda
            </a>
          }
          </div>
        </div>
      </div>
    </div>
  )
}


// has to be class componet to work with library without throwing warnings about refs not working
class DateInput extends React.Component {
  render(){
    const { value, onClick, handleChange} = this.props
    return(
      <input 
        className="text-center form-control"
        onClick={onClick}
        style={{fontSize: '20px'}}
        value={value}
        onChange={()=>handleChange(value)}/>
    )
  }
}

const options = [
  {
    label: 'Agenda',
    value: 'agenda'
  },
  {
    label: 'Week',
    value: 'week'
  },
  {
    label: 'Month',
    value: 'month'
  },
]


const FilterContainer = styled.div`
  @media(max-width: 990px){
    width: 100% !important;
  }
`